import { utils } from '../utils/utils';
import { HttpClient } from './serviceBase';

class CustomerService {
    MapAddress = (address) => ({
        ...address,
        postalCode: address.zipCode,
        city: address.state
    })

    Search = async (request, config) => {
        const queryString = utils.GetQueryStringsFromObject(request);
        return await HttpClient.Get(`/api/Customers/search?${queryString}`, config);
    }

    Get = async (itemId) =>
        await HttpClient.Get(`/api/Customers/${itemId}`);

    Create = async (item) =>
        await HttpClient.Post(`/api/Customers`, item);

    Update = async (item) =>
        await HttpClient.Put(`/api/Customers/${item.id}`, item);

    Delete = async (itemId) =>
        await HttpClient.Delete(`/api/Customers/${itemId}`);
        
    Activate = async (itemId) =>
        await HttpClient.Delete(`/api/Customers/${itemId}/Activate`);

    GetAddresses = async (customerId, request) => {
        const queryString = utils.GetQueryStringsFromObject(request);
        return await HttpClient.Get(`/api/Customers/${customerId}/addresses?${queryString}`);
    }

    CreateAddress = async (customerId, address) =>
        await HttpClient.Post(`/api/Customers/${customerId}/addresses`, address);

    UpdateAddress = async (customerId, address) =>
        await HttpClient.Put(`/api/customers/${customerId}/addresses/${address.id}`, address)

    DeleteAddress = async (customerId, addressId) =>
        await HttpClient.Delete(`/api/customers/${customerId}/addresses/${addressId}`)

    GetTaxConfig = async (customerId) =>
        await HttpClient.Get(`/api/Customers/${customerId}/taxConfig`);
}

export default new CustomerService();